/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomerConfig
 */
export interface CustomerConfig {
    /**
     * 
     * @type {number}
     * @memberof CustomerConfig
     */
    claimFormInactivityTimeoutMs?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerConfig
     */
    freshdeskId?: string | null;
}

/**
 * Check if a given object implements the CustomerConfig interface.
 */
export function instanceOfCustomerConfig(value: object): value is CustomerConfig {
    return true;
}

export function CustomerConfigFromJSON(json: any): CustomerConfig {
    return CustomerConfigFromJSONTyped(json, false);
}

export function CustomerConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'claimFormInactivityTimeoutMs': json['claimFormInactivityTimeoutMs'] == null ? undefined : json['claimFormInactivityTimeoutMs'],
        'freshdeskId': json['freshdeskId'] == null ? undefined : json['freshdeskId'],
    };
}

export function CustomerConfigToJSON(value?: CustomerConfig | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'claimFormInactivityTimeoutMs': value['claimFormInactivityTimeoutMs'],
        'freshdeskId': value['freshdeskId'],
    };
}

